
import React,{Component} from 'react';
import Swiper from 'react-id-swiper';
import LoggedInPage from '../../views/core/LoggedInPage';
import LessonComponent from '../../views/scorecard/LessonComponent';
import HmAjax from '../../util/HmAjax';
import Loader from 'react-loader-spinner';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import $ from 'jquery';
import {
	Accordion,
	AccordionItem,
	AccordionItemTitle,
	AccordionItemBody,
} from 'react-accessible-accordion';

const params = {
		slidesPerView: 'auto',
		paginationClickable: true,
		centeredSlides: true,
	 	spaceBetween: 25,	 	
	 	grabCursor: true,
	 	freeMode: true,
	 	scrollbar: '.swiper-scrollbar',
	 	scrollbarHide: true,
	 	effect: 'fade',
    }

class CustomAccordian extends LoggedInPage{

        constructor(props){
            super(props);
			this.state={dataLoaded:false,data:{},isStarView: false,isAccoView:false}
			this.markedquesFn = this.markedquesFn.bind(this);
			this.likeFn = this.likeFn.bind(this);

			this.ga = this.props.ga || {"subscribe-btn":"scorecard-subscribe"};
		}
		
		likeFn(event) {
			const ratingIcons = document.querySelectorAll('.ratingIcon');
			ratingIcons.forEach(rating => {
				if (rating.classList.contains('selected')) {
					rating.classList.remove('selected');
				}
			})
			event.currentTarget.classList.add("selected");
		}

		markedquesFn(event){
			//event.currentTarget.classList.toggle("selected")
			this.setState({ isStarView: !this.state.isStarView })
		}

		renderlikebtn() {
			return (
				<div className="likebox">
					<p>{this.rb("rating.title")}</p>
					<div className="btngp">
						<span className="ratingIcon" data-id="0" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_up</i></span>
						<span className="ratingIcon" data-id="0" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_down</i></span>
					</div>
				</div>
			)
		}

        handleChange(e) {
			this.setState({ isAccoView: !this.state.isAccoView })
            //console.log("id "+e.target.getAttribute('id'));
            //const acco_arrow=document.querySelector(".acc_arrow");
            //console.log("on change"+acco_arrow.classList)
           
           // acco_arrow.classList.toggle("selected");
            
            var me = this;
            
            if(this.props.similarType.typeName == "question"){            
	            var callBackSuccess = function(response){
	
	                me.setState({dataLoaded:true,data:response})
	               
	                if(response.code === 200){
	                    
	                }else if(response.code === 400) {
	                    
	                }
	                else {
	                    
	                }
	                
	                
	            }
	    
	            var callBackFailure = function(response){
	                console.log("GET_SIMILAR_QUESTION Failure...");
	            }
	            
	            new HmAjax(this.getUrlFor("GET_SIMILAR_QUESTION")+this.props.similarType.similarSnippetId).get(callBackSuccess,callBackFailure);	
            }else if(this.props.similarType.typeName == "lesson"){
            	me.setState({dataLoaded:true})
            }
            
            
            var itemType = (this.props.similarType.typeName == "question") ? "similar_problem" : "recommended_lessons";
            try{
				var trackObj = {
					"test_id": me.props.testId,
					 "snippet_id": me.props.snippetId,
					 "question_source":me.props.source,
				    "item_type": this.getTracker().enums.viewedItemType[itemType],
				    "hidden": this.state.isAccoView
				}
				this.initiateTrack("item_viewed",trackObj);
			}catch(e){
			}
		
		}
		
		getGA(){
			return this.ga["subscribe-btn"];
		}

        renderOptions() {
        	
			if (this.state.data.qsQuestionPojo.questionType === "mcq") {
				return (
					<div name="optionsVw">
						{/* Options: */}
						<ul className="qoption">
							{this.state.data.qsQuestionPojo.options.map(function (option, index) {
								return <li key={index}>{ReactHtmlParser(option.optionImage)}</li>;
							})}
	
						</ul>
					</div>
				)
			} else {
				return (
					<div> </div>)
			}		
		}

        renderaccQuesFn(propsval){
			console.log("recomm pblm :: ",propsval)
            if(this.state.dataLoaded == false){
                return (<div className="text-center">
                <Loader 
		         type="Oval"
		         color="#00BFFF"
		         height="100"	
		         width="50"
		      />
                </div>);
            }else{
				
            	if(this.props.similarType.typeName == "lesson"){
            		console.log("lesson source==",this.props.source);
            		return (
            		<div className="row allMiddle">
	            		<div className="col-12 text-center allMiddle scorecardLessons">
	            			<Swiper className="student-slider" slidesPerView={params.slidesPerView} spaceBetween={params.spaceBetween}>
			    				{this.props.similarType.similarLessonList.map((lesson,index) =>
			    					<LessonComponent isFrom={"Custom Accordian"} isFreeTrail={this.props.recomLocked.recommendedLessonLocked} lesson={lesson} testId={this.props.testId} topicSubTopicMapId={this.props.topicSubTopicMapId} accessId={this.props.accessId} classId={this.props.classId} tracksource="solution_question" snippetId={this.props.snippetId} source={this.props.source} key={index} />
			    				)}
			    			</Swiper>
		    			</div>

						{(()=>{
							
							if(propsval){
								
								return (
									<div className="col-12 text-center allMiddle"> 
									
									{this.subscribeFn(this.getGA()+" - Recommended Lesson - Subscribe")}

									</div>
								)
							}	
							})()}

		    		</div>
	    			);
            	}
            	else if(this.props.similarType.typeName == "question"){
	                return (
	                    <div className="qcontacc">
	                    {/* marked questions hidden -- kamaraj */}
	                        {/*<div className="qstar"><span className="starIcon" onClick={this.markedquesFn}>{ this.state.isStarView
          ? <i className="material-icons strclr">star</i>
          : <i className="material-icons strbclr">star_border</i>
        }</span></div>*/}
	        
	                        <div name="questionView" className="qvroot">
	                            <div className="qView">
	                                
	                                <div className="qvwList">
									<div className="quesorder">{"Q" + (this.state.data.qsQuestionPojo.questionSource)}</div>
									<div className="qVw scrollEqn">
										<div name="questionVw scrollEqn">
	                                        <div>
	                                            {ReactHtmlParser(this.state.data.qsQuestionPojo.questionText)}
	                                        </div>
	                                    </div>
	                                    {this.renderOptions()}
	                                    <div className="scrollEqn">
	                                    <span>{this.rb("scorecard.correct_answer")}:</span>{ReactHtmlParser(this.state.data.qsQuestionPojo.correctOptionsDisplay)}
	                                    </div>
										</div>
	                                </div>
	                            </div>
	        
	                            <div name="solutionVw">
	                                <div className="qsoln scrollEqn">
									{/* {this.renderlikebtn()} */}
	                                    <p>{this.rb("editor.solutionTitle")}:</p>
	                                    {ReactHtmlParser(this.state.data.qsQuestionPojo.solutionText)}
	                                </div>
	        
	                            </div>
	                        </div>
	                    </div>
	                )
            	}
            }
		}

		lockcontent(props){
			if(props){
				return(
					<span className="upgrdlock1"><i class="material-icons">lock</i></span>
					)	 
			}
		}

        renderRecommendedItem(){
			var me=this;
        	if(this.props.similarType.typeName == "question"){
        		return (<div className="quesbg"><span className="spblmbtn" >{me.rb("scorecard.similar_problem")} { this.state.isAccoView
					? <i className="material-icons acc_arrow selected">arrow_drop_up</i>
					: <i className="material-icons acc_arrow">arrow_drop_up</i>
				  }</span> </div>);
        	}else if(this.props.similarType.typeName == "lesson"){
                return (<div className="quesbg"><span className="spblmbtn" >{this.rb("scorecard.recommended_lesson")} { this.state.isAccoView
					? <i className="material-icons acc_arrow selected">arrow_drop_up</i>
					: <i className="material-icons acc_arrow">arrow_drop_up</i>
				  } </span> {this.lockcontent(this.props.recomLocked.recommendedLessonLocked)} </div>);
            }
		}
		
        render(){
			var classdisabled = "";	
					if(this.props.recomLocked.similarProblemLocked){
						classdisabled = "disabled lockdisabled";
					}

					var lessonLocked = this.props.recomLocked.recommendedLessonLocked || false;

			if(this.props.recomLocked.similarProblemLocked){
				if(this.props.similarType.typeName == "question"){
					return(
						<div><span className={"spblmbtn"+classdisabled} >{this.rb("scorecard.similar_problem")} <i className="material-icons acc_arrow">arrow_drop_up</i> </span> <span className="upgrdlock"><i class="material-icons">lock</i></span> {this.subscribeFn(this.getGA()+" - Subscribe")} </div>
					)
					}
				else{
					return(
						<Accordion className="accBox" onChange={this.handleChange.bind(this)}>
							<AccordionItem className="accitem">
								<AccordionItemTitle className="acctitle">
									{this.renderRecommendedItem()}	                          
								</AccordionItemTitle>
								<AccordionItemBody>
									<div>
										{this.renderaccQuesFn(lessonLocked)}
									</div>
								</AccordionItemBody>
							</AccordionItem>
						</Accordion>
					)
					}
				}
			else{
				return(
				<Accordion className="accBox" onChange={this.handleChange.bind(this)}>
					<AccordionItem className="accitem">
						<AccordionItemTitle className="acctitle">
							{this.renderRecommendedItem()}	                            
						</AccordionItemTitle>
						<AccordionItemBody>
							<div>
								{this.renderaccQuesFn(lessonLocked)}
							</div>
						</AccordionItemBody>
					</AccordionItem>
				</Accordion>
				)
			}			        
        }
    
}

export default CustomAccordian;


// WEBPACK FOOTER //
// ./src/components/question/CustomAccordian.js